import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { transformCloudinaryUrl, getLqipUrl, CloudinaryOptions } from '../../utils/cloudinary.utils';

@Component({
  selector: 'app-lazy-image',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="relative overflow-hidden w-full h-full bg-[#f3f4f6]" [class.shimmer]="!isLoaded && !useLqip">
      <!-- LQIP Placeholder -->
      <img
        *ngIf="useLqip && !isLoaded"
        [src]="lqipUrl"
        class="absolute inset-0 w-full h-full object-cover blur-lg scale-110 transition-opacity duration-500"
        [class.opacity-0]="isLoaded"
        alt="Loading..."
      />

      <!-- Main Image -->
      <img
        [src]="currentUrl"
        [alt]="alt"
        [class]="imageClass"
        [loading]="priority ? 'eager' : 'lazy'"
        [attr.fetchpriority]="priority ? 'high' : 'auto'"
        (load)="onLoad()"
        class="w-full h-full transition-opacity duration-700 ease-in-out"
        [class.opacity-0]="!isLoaded"
        [class.opacity-100]="isLoaded"
      />
    </div>
  `,
  styles: [`
    :host { display: block; width: 100%; height: 100%; }
    .shimmer {
      background: linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite;
    }
    @keyframes shimmer {
      0% { background-position: -200% 0; }
      100% { background-position: 200% 0; }
    }
  `]
})
export class LazyImageComponent implements OnInit, OnChanges {
  @Input() src: string | undefined | null = '';
  @Input() alt: string = '';
  @Input() imageClass: string = 'object-cover';
  @Input() width?: number;
  @Input() height?: number;
  @Input() priority: boolean = false;
  @Input() useLqip: boolean = true;

  isLoaded = false;
  currentUrl: string = '';
  lqipUrl: string = '';

  ngOnInit() {
    this.updateUrls();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['src'] || changes['width'] || changes['height']) {
      this.updateUrls();
    }
  }

  private updateUrls() {
    if (!this.src) {
      this.currentUrl = '/assets/placeholder-botanical.jpg';
      this.lqipUrl = '';
      return;
    }

    const options: CloudinaryOptions = {
      width: this.width,
      height: this.height,
      crop: 'fill'
    };

    this.currentUrl = transformCloudinaryUrl(this.src, options);
    
    if (this.useLqip) {
      this.lqipUrl = getLqipUrl(this.src);
    }
  }

  onLoad() {
    this.isLoaded = true;
  }
}
